/**
 * Ponte entre o estado do filtro (mês como "YYYY-MM") e o seletor de data do sistema
 * (GenericDatePickerReference, que trabalha com `Date`).
 */

/** Marcador guardado no filtro quando o usuário deixa a data pela metade ("06/20"). */
export const MES_INVALIDO = "invalido";

/** "2024-03" → Date do dia 1º do mês (local). Vazio, marcador ou formato inválido → null. */
export function mesIsoParaData(iso) {
  const m = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(iso == null ? "" : String(iso));
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, 1) : null;
}

/** Date → "YYYY-MM"; campo limpo → ""; data incompleta/inválida → MES_INVALIDO. */
export function dataParaMesIso(data) {
  if (data == null) return "";
  if (!(data instanceof Date) || Number.isNaN(data.getTime())) return MES_INVALIDO;
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}`;
}
